import { render, staticRenderFns } from "./AvgPtax.vue?vue&type=template&id=45b443b0&scoped=true"
import script from "./AvgPtax.vue?vue&type=script&lang=js"
export * from "./AvgPtax.vue?vue&type=script&lang=js"
import style0 from "./AvgPtax.vue?vue&type=style&index=0&id=45b443b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b443b0",
  null
  
)

export default component.exports